import { ServiceTypesState } from '../../../../@types';

const initialState: ServiceTypesState = [];
export default initialState;
